import type { SVGProps } from 'react'

export const ArrowRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="currentColor"
    aria-hidden="true"
    style={{ width: 20 }}
    {...props}
  >
    <path d="M64 32a2.92 2.92 0 0 0-.85-2.06L51.52 18.31c-1.14-1.14-2.98-1.14-4.11 0s-1.14 2.98 0 4.11l6.67 6.67H2.91C1.3 29.09 0 30.39 0 32s1.3 2.91 2.91 2.91h51.16l-6.67 6.67a2.897 2.897 0 0 0 0 4.11c.57.57 1.31.85 2.06.85s1.49-.28 2.06-.85l11.63-11.64a2.92 2.92 0 0 0 .85-2.06Z" />
  </svg>
)

export const ArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="currentColor"
    aria-hidden="true"
    style={{ width: 20 }}
    {...props}
  >
    <path d="M0 32a2.92 2.92 0 0 0 .85 2.06l11.63 11.63c1.14 1.14 2.98 1.14 4.11 0s1.14-2.98 0-4.11l-6.67-6.67h51.16c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H9.93l6.67-6.67a2.897 2.897 0 0 0 0-4.11c-.57-.57-1.31-.85-2.06-.85s-1.49.28-2.06.85L.85 29.94A2.92 2.92 0 0 0 0 32" />
  </svg>
)
